import {
  type ShipmentDeliveryStatusType,
  SHIPMENT_DELIVERY_STATUS_TYPE
} from '@/libs/api/types'

/**
 * 配送ステータス（時系列10段階 + 軸跨ぎ2値）の色マップ。
 * StatusTag の color props と同じ値を使う。
 * ShipmentDeliveryStatusTypeTag / EditableDeliveryStatusTag / ShipmentDeliveryStatusDot で共有。
 */
export type ShipmentDeliveryStatusColor =
  | 'primary'
  | 'secondary'
  | 'info'
  | 'green'
  | 'yellow'
  | 'red'
  | 'orange-5'
  | 'orange-6'
  | 'orange-7'
  | 'blue-5'
  | 'green-7'
  | 'green-8'

export const SHIPMENT_DELIVERY_STATUS_COLOR_MAP: Record<
  ShipmentDeliveryStatusType,
  ShipmentDeliveryStatusColor
> = {
  [SHIPMENT_DELIVERY_STATUS_TYPE.UNORDERED]: 'secondary',
  [SHIPMENT_DELIVERY_STATUS_TYPE.BEFORE_DISPATCH]: 'red',
  [SHIPMENT_DELIVERY_STATUS_TYPE.DISPATCHING]: 'primary',
  // VOC_PJ-832 #3474: 配車確定以降（確定群）は未確定(DISPATCHING)と業務的境界が大きいため緑系で 3 段階に分ける
  [SHIPMENT_DELIVERY_STATUS_TYPE.DISPATCH_CONFIRMED]: 'green',
  [SHIPMENT_DELIVERY_STATUS_TYPE.TRUCK_NOTIFIED]: 'green-7',
  [SHIPMENT_DELIVERY_STATUS_TYPE.DELIVERY_INSTRUCTED]: 'green-8',
  // 当日進捗（誘導〜完了）は暖色系
  [SHIPMENT_DELIVERY_STATUS_TYPE.SAME_DAY_GUIDED]: 'yellow',
  [SHIPMENT_DELIVERY_STATUS_TYPE.LOADING_COMPLETED]: 'orange-5',
  [SHIPMENT_DELIVERY_STATUS_TYPE.UNLOADING_COMPLETED]: 'orange-6',
  [SHIPMENT_DELIVERY_STATUS_TYPE.DELIVERY_COMPLETED]: 'orange-7',
  [SHIPMENT_DELIVERY_STATUS_TYPE.CANCELLED]: 'secondary',
  // VOC_PJ-981 #4620: 取消もキャンセルと同じ軸跨ぎのためグレー系に揃える
  [SHIPMENT_DELIVERY_STATUS_TYPE.REVOKED]: 'secondary'
}
